var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3C13.8645 3 10.5 6.3645 10.5 10.5V15H9C8.20435 15 7.44129 15.3161 6.87868 15.8787C6.31607 16.4413 6 17.2044 6 18V30C6 30.7956 6.31607 31.5587 6.87868 32.1213C7.44129 32.6839 8.20435 33 9 33H27C27.7956 33 28.5587 32.6839 29.1213 32.1213C29.6839 31.5587 30 30.7956 30 30V18C30 17.2044 29.6839 16.4413 29.1213 15.8787C28.5587 15.3161 27.7956 15 27 15H25.5V10.5C25.5 6.3645 22.1355 3 18 3ZM13.5 10.5C13.5 8.019 15.519 6 18 6C20.481 6 22.5 8.019 22.5 10.5V15H13.5V10.5ZM19.5 26.5845V30H16.5V26.5845C15.9756 26.2842 15.5545 25.832 15.2922 25.2875C15.03 24.7431 14.9389 24.1319 15.031 23.5347C15.1231 22.9374 15.3941 22.3821 15.8081 21.9419C16.2222 21.5017 16.76 21.1974 17.3505 21.069C17.7891 20.972 18.2439 20.9747 18.6814 21.0769C19.1188 21.1791 19.5277 21.3782 19.878 21.6595C20.2282 21.9408 20.5109 22.2971 20.7051 22.7022C20.8993 23.1073 21 23.5508 21 24C20.9991 24.5246 20.86 25.0397 20.5967 25.4935C20.3334 25.9472 19.9551 26.3235 19.5 26.5845Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.5fc19fddef3026ae5de1f3661342bb8e.svg";
export { ForwardRef as ReactComponent };